export enum BookingMealOption {
  no_meals,
  with_breakfast,
  breakfast_with_dinner,
}
export enum MealOptions {
  no_meals = 'no_meals',
  with_breakfast = 'with_breakfast',
  breakfast_with_dinner = 'breakfast_with_dinner',
}

export enum MealValues {
  breakfast = 'breakfast',
  dinner = 'dinner',
}
